export const CHART_HEIGHT = 450;

export const AIRLINE_SERIES_COLORS = [
  "var(--bui_color_cta_background)",
  "var(--bui_color_accent_background)",
  "var(--bui_color_callout_background)",
  "var(--bui_color_constructive_background)",
  "var(--bui_color_destructive_background)",
  "var(--bui_color_brand_primary_background)",
  "var(--bui_color_accent_foreground)",
  "var(--bui_color_callout_foreground)",
  "var(--bui_color_constructive_foreground)",
  "var(--bui_color_destructive_foreground)",
];
